import type { Schema } from '@dealdesk/api-schema';
import { z } from 'zod';

import { M, zDateOnly, zEmiratesId, zOptionalMoney, zRequiredString, zUaeMobile } from '@/business';

export const customerCreateSchema = z.object({
  name: zRequiredString(),
  nameAr: z.string().optional(),
  emiratesId: zEmiratesId(),
  mobile: zUaeMobile(),
  email: z.union([z.literal(''), z.email(M.email)]).optional(),
  dateOfBirth: zDateOnly(),
  nationality: zRequiredString(),
  employer: z.string().optional(),
  monthlySalary: zOptionalMoney(),
});
export type CustomerCreateValues = z.infer<typeof customerCreateSchema>;

export const customerCreateDefaults: CustomerCreateValues = {
  name: '',
  nameAr: '',
  emiratesId: '',
  mobile: '',
  email: '',
  dateOfBirth: '',
  nationality: '',
  employer: '',
  monthlySalary: null,
};

export function toCustomerCreate(v: CustomerCreateValues): Schema<'CustomerCreate'> {
  return {
    name: v.name.trim(),
    emiratesId: v.emiratesId,
    mobile: v.mobile,
    dateOfBirth: v.dateOfBirth,
    nationality: v.nationality,
    ...(v.nameAr?.trim() ? { nameAr: v.nameAr.trim() } : {}),
    ...(v.email?.trim() ? { email: v.email.trim() } : {}),
    ...(v.employer?.trim() ? { employer: v.employer.trim() } : {}),
    ...(v.monthlySalary ? { monthlySalary: v.monthlySalary } : {}),
  };
}
